import { hideOverlay, showOverlay } from "./block-page-for-user";
export function ajaxStartExample($) {
  var ajaxTest = document.querySelector('.ajax-test');
  if (!ajaxTest) return;
  var overlayElement = document.getElementById('block-user-on-reload-page');
  var formData = new FormData();
  formData.append('action', 'name_my_ajax_action'); // used in backend for: wp_ajax_, wp_ajax_nopriv_
  formData.append('keyForGlobalPostArrayInPhpOne', 'value one');
  formData.append('keyForGlobalPostArrayInPhpTwo', 'value two');
  formData.append('nonce_my_custom_name', think_localize_obj.ajax_nonce);
  ajaxTest.addEventListener('click', function (event) {
    event.preventDefault();
    showOverlay(overlayElement, 'Ajax is working...');
    $.ajax({
      url: think_localize_obj.ajax_url,
      type: 'POST',
      dataType: 'json',
      data: formData,
      processData: false,
      // ! if want send FormData: tell jQuery not to process the data
      contentType: false,
      // ! if want send FormData: tell jQuery not to set contentType
      success: function success(response) {
        if (0 === response.length) {
          alert('Issue with passed variables');
          hideOverlay(overlayElement);
        } else if (response.warning_nonce) {
          alert(response.warning_nonce);
          showOverlay(overlayElement, 'Page is reloading...');
          location.reload(); // Reload the page
        } else {
          alert(response.backend_response);
          hideOverlay(overlayElement);
        }
      },
      error: function error(jqXHR, textStatus, errorThrown) {
        console.log("An error occurred during your request: ".concat(jqXHR.status, " ").concat(textStatus, " ").concat(errorThrown));
      }
    });
  });
}